import { render, staticRenderFns } from "./AdminRainElement.vue?vue&type=template&id=2b54fd0d&scoped=true"
import script from "./AdminRainElement.vue?vue&type=script&lang=js"
export * from "./AdminRainElement.vue?vue&type=script&lang=js"
import style0 from "./AdminRainElement.vue?vue&type=style&index=0&id=2b54fd0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b54fd0d",
  null
  
)

export default component.exports